import { render, staticRenderFns } from "./MetricItemSubtitle.vue?vue&type=template&id=cdfa85f4&scoped=true&"
import script from "./MetricItemSubtitle.vue?vue&type=script&lang=js&"
export * from "./MetricItemSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./MetricItemSubtitle.vue?vue&type=style&index=0&id=cdfa85f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdfa85f4",
  null
  
)

export default component.exports